// extracted by mini-css-extract-plugin
export var avatarContainer = "_g0-0";
export var avatarTypingWave = "_g0-i";
export var gray = "_g0-f";
export var green = "_g0-c";
export var icon = "_g0-9";
export var image = "_g0-1";
export var lg = "_g0-6";
export var md = "_g0-5";
export var presenceDot = "_g0-b";
export var red = "_g0-d";
export var sm = "_g0-4";
export var status = "_g0-a";
export var typingDot = "_g0-h";
export var typingPill = "_g0-g";
export var xl = "_g0-7";
export var xs = "_g0-3";
export var xxl = "_g0-8";
export var xxs = "_g0-2";
export var yellow = "_g0-e";